export abstract class BootstrapService {
  abstract getCarousel(element: string | Element, opt?: any): any;

  abstract getCollapse(element: string | Element, opt?: any): any;

  abstract getModal(element: string | Element, opt?: any): any;

  abstract getOffcanvas(element: string | Element, opt?: any): any;

  abstract getBootstrapClassByName(name: string): any;
}
